// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class TaskTemplateResource extends Resource {
    basePath: string = 'tasks/template/';

    objectPath: string = 'tasks/template/{ident}/';
}
